import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as DefaultViewExtensionInterfaces from '#/DefaultViewExtensionInterfaces';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class FancyTreeViewModel extends ControlViewModel {
    public nodes: KnockoutObservableArray<Fancytree.NodeData>
    public extensions: Array<string>;
    public renderCheckboxes: boolean;
    public renderIcons: boolean;
    public autoScroll: boolean;
    public escapeHtml: boolean;
    public selectMode: Fancytree.FancytreeSelectMode;
    private captions: KnockoutObservableArray<LabelViewModel>;
    public lazyLoad: (event, data) => void;

    private validationSubscriptions = [];

    public selected: KnockoutObservable<Fancytree.FancytreeNode>;
    public activeNode: KnockoutObservable<string>;

    public constructor(protected params: ConstructorParameter) {
        super(params);

        this.captions = this.observableOrDefault(params.captions, []) as KnockoutObservableArray<any>;
        this.nodes = this.observableOrDefault(params.nodes, []).extend({ notify: 'always' }) as KnockoutObservableArray<any>;
        this.extensions = this.paramOrDefault(params.extensions, ["table"]);
        this.renderCheckboxes = this.paramOrDefault(params.renderCheckboxes, false);
        this.renderIcons = this.paramOrDefault(params.renderIcons, false);
        this.selected = this.paramOrDefault(this.observableOrDefault(null));        
        this.activeNode = this.observableOrDefault('');
        this.autoScroll = this.paramOrDefault(params.autoScroll, false);
        this.escapeHtml = this.paramOrDefault(params.escapeHtml, true);
        this.lazyLoad = params.lazyLoad;

        if (params.selectMode) {
            this.selectMode = params.selectMode;
        }

        this.defineIsValidState();
    }

    private defineIsValidState(): void {
        var self = this;

        self.defineSubscription(self.nodes, (nodes: Array<NodeData>) => {
            let leafs = self.extractLeafNodes(nodes);

            for (let subscription of self.validationSubscriptions) {
                subscription.dispose();
            }
            self.validationSubscriptions = [];

            for (let leaf of leafs) {
                let nodeViewModel = self.getNodeViewModel(leaf);
                if (nodeViewModel) {
                    self.validationSubscriptions.push(
                        nodeViewModel.isValid.subscribe((isValid) => {
                            self.calculateIsValid(leafs);
                        })
                    );
                }
            }
            self.calculateIsValid(leafs);

        })(self.nodes());
    }

    private calculateIsValid(leafs: Array<NodeData>): void {
        for (let leaf of leafs) {
            let nodeViewModel = this.getNodeViewModel(leaf);

            if (nodeViewModel && !nodeViewModel.isValid()) {
                this.isValid(false);
                return;
            }
        }
        this.isValid(true);
    }

    private extractLeafNodes(nodes: Array<NodeData>): Array<NodeData> {
        let leafs = [];
        for (let node of nodes) {
            if (this.isLeaf(node)) {
                leafs.push(node);
            }
            else {
                leafs.push.apply(leafs, this.extractLeafNodes(node.children));
            }
        }
        return leafs;
    }

    private isLeaf(node: NodeData): boolean {
        return node.children == undefined || node.children == null ||
            (node.children instanceof Array && node.children.length <= 0);
    }

    private getNodeViewModel(node: NodeData) {
        return node.nodeViewModel
    }
}

type NodeData = DefaultViewExtensionInterfaces.NodeData;
type ConstructorParameter = DefaultViewExtensionInterfaces.IFancyTreeViewModelConstructorParameter;

ComponentManager.setViewModel('FancyTreeViewModel', FancyTreeViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');